
interface ScrollToElementOptions {
    duration: number;
    offset: number;
}

export const scrollIntoView = (elementId: string) => {
    const element = document.getElementById(elementId);
    element?.scrollIntoView({ behavior: "smooth" });
}

export const scrollToElement = (elementId: string, options: ScrollToElementOptions = {duration: 1000, offset: 0}) => {
    const element = document.getElementById(elementId)
    if (element) {
        const offsetTop = element.offsetTop + options.offset;
        smoothScrollTo(offsetTop, options.duration);
      }
  }
export const scrollToTop = (options: ScrollToElementOptions = {duration: 1000, offset: 0}) => {
    smoothScrollTo(options.offset, options.duration)
}

const smoothScrollTo = (targetPosition: number, duration: number = 1000) => {
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;

    let startTime: number;

    function scrollAnimation(currentTime: number) {
    if (!startTime) {
        startTime = currentTime;
    }

    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easeInOutCubic = progress < 0.5 ? 4 * progress ** 3 : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;
    window.scrollTo(0, startPosition + distance * easeInOutCubic);

    if (timeElapsed < duration) {
        requestAnimationFrame(scrollAnimation);
    }
    }

    requestAnimationFrame(scrollAnimation);
}